export default __webpack_public_path__ + "static/media/3.e6108596.svg";